import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import login from '../components/login/login'
import success from '../components/buy/success'
import index from  '../components/index/index'
import buy from '../components/buy/buy'
import courselist from '../components/buy/courselist'
import offcourselist from '../components/buy/offcourselist'
import coursedetail from '../components/buy/coursedetail.vue'
import coursedetailxcx from '../components/buy/coursedetailxcx.vue'
import question from '../components/question/qus1'
import que1 from '../components/question/qus2'
import que2 from '../components/question/qus3'
import que3 from '../components/question/qus4'
import que4 from '../components/question/qus5'
import jieguo from '../components/question/jieguo'
import ceping from '../components/question/ceping'
import ceping1 from '../components/question/ceping1'
import ceping2 from '../components/question/ceping2'
import ceping3 from '../components/question/ceping3'
import ceping4 from '../components/question/ceping4'
import zhuanhuan from '../components/other/zhuanhuan'
import zhuanhuan1 from '../components/other/zhuanhuan1'
import zhuanhuan2 from '../components/other/zhuanhuan2'
import changeScore from '../components/other/changeScore'
import about from '../components/other/about'
import linkus from '../components/other/linkus'
import vip from '../components/other/vip'
import ziliao from '../components/center/ziliao'
import jiaoyu from '../components/center/editjiaoyu'
import job from '../components/center/addjob'
import order from '../components/center/order'
import orderdetail from '../components/center/orderdetail'
import jilu from '../components/center/jilu'
import jifen from '../components/center/jifen'
import plan from '../components/center/plan'
import plandetail from '../components/center/plandetail'
import shoucang from '../components/center/shoucang'
import msg from '../components/center/msg'
import msgdetail from '../components/center/msgdetail'
import chongzhi from '../components/center/chongzhi'
import xieyi from '../components/center/xieyi'
import fapiaojilu from '../components/center/fapiaojilu'
import applyfapiao from '../components/center/applyfapiao'
import ablity from '../components/center/ablity'
import ablity_xuefen from '../components/center/ablity_xuefen'
import ablity_job from '../components/center/ablity_job'
import ablity_leida from '../components/center/ablity_leida'
import ablity_tianti from '../components/center/ablity_tianti'
import search from '../components/buy/jieguo'
import zhibolist from '../components/buy/zhibolist'
import zhibodetail from '../components/buy/zhibodetail'
import offcoursedetail from '../components/buy/offcoursedetail'
import rule from '../components/center/rule'
import cepingxieyi from '../components/question/xieyi'
import kefu from '../components/center/kefu'
import lecturerlist from '../components/buy/lecturerlist'
import bankbuy from '../components/buy/bankbuy'
import html from '../components/buy/html'
import sliderhtml from '../components/buy/sliderhtml'
import center from '../components/template/center'
//学分转换
import kaoshilist from '../components/center/kaoshilist.vue'
import xuefen from '../components/center/xuefen.vue'
import myzhengshu from '../components/center/myzhengshu.vue'
import myzhengshubaokao from '../components/center/myzhengshubaokao.vue'
import xuefenrending from '../components/changeScore/xuefenrending.vue'
import renzheng from '../components/changeScore/renzheng'
import zhengshuchaxun from '../components/changeScore/zhengshuchaxun'
import zhengshulist from '../components/changeScore/myzhengshu'
import zhengshu from '../components/changeScore/zhengshu'
import confirmrending from '../components/changeScore/xuefendetail'
import rendingsuccess from '../components/changeScore/rendingsuccess'
import step from '../components/changeScore/step'
import step1 from '../components/changeScore/step1'
import step2 from '../components/changeScore/step2'
import step3 from '../components/changeScore/step3'
import step4 from '../components/changeScore/step4'
import jixujiaoyu from '../components/center/jixujiaoyu.vue'
import shenbao from '../components/center/shenbao.vue'
import shenbaosuccess from '../components/center/shenbaosuccess'
import shenbaojilu from '../components/center/shenbaojilu.vue'
import zhengshudetail from '../components/center/zhengshudetail.vue'
import zhengshurending from '../components/center/zhengshurending.vue'
import xuefendetail from '../components/center/xuefendetail.vue'
import mykaoshi from '../components/center/mykaoshi.vue'
import kaoshiziliao from '../components/center/kaoshiziliao.vue'
import college from '../components/other/college.vue'

//认证考试
import kaoshi from '../components/examination/index'
import startkaoshi from '../components/examination/kaoshi'
import kaoshiAccount from '../components/examination/account'
import shenfen from '../components/examination/shenfen'
import hasjiaoyu from '../components/examination/education/hasjiaoyu'
import addEducation from '../components/examination/education/addEducation'
import jobjingli from '../components/examination/work/job'
import addjob from '../components/examination/work/addjob'
import peixun from '../components/examination/cultivate/peixun'
import addpeixun from '../components/examination/cultivate/addpeixun'
import haszhengshu from '../components/examination/certificate/zhengshu'
import addzhengshu from '../components/examination/certificate/addzhengshu'
import applyExa from '../components/examination/apply/baokao'
import buyExam from '../components/examination/buy'
import myExamPage from '../components/examination/myExam/kaoshilist1'
import nextjiaoyu from '../components/continuEducation/jiaoyu.vue'
import continuBuy from '../components/continuEducation/continuBuy'
import zhengming from '../components/continuEducation/zhengming'
import continuCourseDetail from '../components/continuEducation/continuCourseDetail'
import xuefentransform from '../components/continuEducation/xuefentransform'
import applayjilu from '../components/continuEducation/applayjilu'
//行业证书
import hangyezhengshu from '../components/certificate/hangyezhengshu'
import baokao from '../components/certificate/baokao'
import chaxun from '../components/certificate/chaxun'
import dengji from '../components/certificate/dengji'
import jiaofei from '../components/certificate/jiaofei'
//继续教育
import continues from '../components/education/jixujiaoyu'
import shenbaoactive from '../components/education/shenbao'
import buysuccess from '../components/education/shenbaosuccess'
import jilushenbao from '../components/education/shenbaojilu'
//帮助中心、新闻
import news from '../components/other/news'
import newsdetail from '../components/other/newsdetail'
import help from '../components/other/help'
import helpdetail from '../components/other/helpdetail'
import lecRecomlist  from '../components/buy/lecRecomlist'
import xieyicommon from '../components/question/xieyicommon'
import global from '../components/other/global'

import occupation from '../components/other/occupation'
import skill from '../components/other/skill'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '勤博教育首页'
      }
    },
    //新增新闻、帮助中心
    {
      path:'/news',
      name:'news',
      component:news,
      // redirect: '/news/news',
      meta:{
        title:'勤博教育 | 新闻时讯'
      },
      // children:[
      //   {
      //     path:'news',
      //     name:'news',
      //     component:news,
      //     meta:{
      //       title:'勤博教育 | 新闻时讯'
      //     },
      //   },
      //   {
      //     path:'newsdetail',
      //     name:'newsdetail',
      //     component:newsdetail,
      //     meta:{
      //       title:'勤博教育 | 新闻详情'
      //     }
      //   },
      // ]
    },
    {
        path:'/newsdetail',
        name:'newsdetail',
        component:newsdetail,
        meta:{
          title:'勤博教育 | 新闻详情'
        }
      },
    //新增新闻、帮助中心
    {
      path:'/help',
      name:'help',
      component:help,
      // redirect: '/help/help',
      meta:{
        title:'勤博教育 | 帮助中心'
      },
      // children:[
      //   {
      //     path:'helpdetail',
      //     name:'helpdetail',
      //     component:helpdetail,
      //     meta:{
      //       title:'勤博教育 | 帮助中心'
      //     }
      //   },
      // ]
    },
    {
        path:'/helpdetail',
        name:'helpdetail',
        component:helpdetail,
        meta:{
          title:'勤博教育 | 帮助中心'
        }
      },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        title: '勤博教育 | 手机号绑定'
      }
    },
    {
      path: '/xieyicommon',
      name: 'xieyicommon',
      component: xieyicommon,
      meta: {
        title: '勤博教育 | 服务协议'
      }
    },
    {
      path: '/html',
      name: 'html',
      component: html,
      meta: {
        // title: '勤博教育 | 协议'
      }
    },
    {
      path: '/sliderhtml',
      name: 'sliderhtml',
      component: sliderhtml,
      meta: {
        title: '勤博教育 | 推荐'
      }
    },
    {
      path: '/bankbuy',
      name: 'bankbuy',
      component: bankbuy,
      meta: {
        title: '勤博教育 | 银联支付'
      }
    },
    {
      path: '/success',
      name: 'success',
      component: success,
      meta: {
        title: '勤博教育 | 支付成功'
      }
    },
    {
      path: '/kefu',
      name: 'kefu',
      component: kefu,
      meta: {
        title: '勤博教育 | 我的客服'
      }
    },
    {
      path: '/cepingxieyi',
      name: 'cepingxieyi',
      component: cepingxieyi,
      meta: {
        title: '勤博教育 | 测评协议'
      }
    },
    {
      path: '/zhibodetail',
      name: 'zhibodetail',
      component: zhibodetail,
      meta: {
        title: '勤博教育 | 在线直播详情'
      }
    },
    {
      path: '/offcoursedetail',
      name: 'offcoursedetail',
      component: offcoursedetail,
      meta: {
        title: '勤博教育 | 线下课程详情'
      }
    },
    {
      path: '/zhibolist',
      name: 'zhibolist',
      component: zhibolist,
      meta: {
        title: '勤博教育 | 在线直播列表'
      }
    },{
      path: '/lecRecomlist',
      name: 'lecRecomlist',
      component: lecRecomlist,
      meta: {
        title: '勤博教育 | 推荐讲师列表'
      }
    },{
      path: '/lecturerlist',
      name: 'lecturerlist',
      component: lecturerlist,
      meta: {
        title: '勤博教育 | 讲师课程列表'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: search,
      meta: {
        title: '勤博教育 | 搜索课程'
      }
    },
    {
      path: '/offcourselist',
      name: 'offcourselist',
      component: offcourselist,
      meta: {
        title: '勤博教育 | 线下课程列表'
      }
    },
    {
      path: '/ziliao',
      name: 'ziliao',
      component: center,
      redirect: '/ziliao/ziliao',
      meta: {
        title: '勤博教育 | 账号资料'
      },
      children:[{
        path: 'ziliao',
        name: 'ziliao',
        component: ziliao,
        meta: {
          title: '勤博教育 | 账号资料'
        },
      },{
        path: 'order',
        name: 'order',
        component: order,
        meta: {
          title: '勤博教育 | 我的订单'
        }
      },{
        path: 'myExamPage',
        name: 'myExamPage',
        component: myExamPage,
        meta: {
          title: '勤博教育 | 我的考试'
        }
      },{
        path: 'jixujiaoyu',
        name: 'jixujiaoyu',
        component: jixujiaoyu,
        meta: {
          title: '勤博教育 | 继续教育'
        }
      },{
        path: 'shenbaosuccess',
        name: 'shenbaosuccess',
        component: shenbaosuccess,
        meta: {
          title: '勤博教育 | 继续教育'
        }
      },{
        path: 'myzhengshu',
        name: 'myzhengshu',
        component: myzhengshu,
        meta: {
          title: '勤博教育 | 我的证书'
        }
      },{
        path: 'myzhengshubaokao',
        name: 'myzhengshubaokao',
        component: myzhengshubaokao,
        meta: {
          title: '勤博教育 | 我的证书'
        }
      },{
        path: 'zhengshudetail',
        name: 'zhengshudetail',
        component: zhengshudetail,
        meta: {
          title: '勤博教育 | 我的证书'
        }
      },{
        path: 'zhengshurending',
        name: 'zhengshurending',
        component: zhengshurending,
        meta: {
          title: '勤博教育 | 我的证书'
        }
      },{
        path: 'xuefendetail',
        name: 'xuefendetail',
        component: xuefendetail,
        meta: {
          title: '勤博教育 | 我的证书'
        }
      },{
        path: 'shenbao',
        name: 'shenbao',
        component: shenbao,
        meta: {
          title: '勤博教育 | 活动申报'
        }
      },{
        path: 'shenbaojilu',
        name: 'shenbaojilu',
        component: shenbaojilu,
        meta: {
          title: '勤博教育 | 申报记录'
        }
      },{
        path: 'xuefen',
        name: 'xuefen',
        component: xuefen,
        meta: {
          title: '勤博教育 | 学分认定'
        }
      },{
        path: 'mykaoshi',
        name: 'mykaoshi',
        component: mykaoshi,
        meta: {
          title: '勤博教育 | 我的考试'
        }
      },{
        path: 'kaoshilist',
        name: 'kaoshilist',
        component: kaoshilist,
        meta: {
          title: '勤博教育 | 我的考试'
        }
      },{
        path: 'kaoshiziliao',
        name: 'kaoshiziliao',
        component: kaoshiziliao,
        meta: {
          title: '勤博教育 | 我的考试'
        }
      },{
        path: 'jiaoyu',
        name: 'jiaoyu',
        component: jiaoyu,
        meta: {
          title: '勤博教育 | 我的教育经历'
        }
      }, {
        path: 'job',
        name: 'job',
        component: job,
        meta: {
          title: '勤博教育 | 添加工作经历'
        }
      },{
        path: 'orderdetail',
        name: 'orderdetail',
        component: orderdetail,
        meta: {
          title: '勤博教育 | 订单详情'
        }
      },{
        path: 'xieyi',
        name: 'xieyi',
        component: xieyi,
        meta: {
          title: '勤博教育 | 学习币使用'
        }
      },    {
        path: 'chongzhi',
        name: 'chongzhi',
        component: chongzhi,
        meta: {
          title: '勤博教育 | 我的学习币'
        }
      },{
        path: 'jilu',
        name: 'jilu',
        component: jilu,
        meta: {
          title: '勤博教育 | 观看记录'
        }
      },
      {
        path: 'rule',
        name: 'rule',
        component: rule,
        meta: {
          title: '勤博教育 | 积分规则'
        }
      },{
        path: 'ablity',
        name: 'ablity',
        component: ablity,
        meta: {
          title: '勤博教育 | 我的能力'
        }
      },{
        path: 'ablity_job',
        name: 'ablity_job',
        component: ablity_job,
        meta: {
          title: '勤博教育 | 我的工作分'
        }
      },{
        path: 'ablity_tianti',
        name: 'ablity_tianti',
        component: ablity_tianti,
        meta: {
          title: '勤博教育 | 能力天梯'
        }
      },{
        path: 'ablity_leida',
        name: 'ablity_leida',
        component: ablity_leida,
        meta: {
          title: '勤博教育 | 能力雷达图'
        }
      },{
        path: 'ablity_xuefen',
        name: 'ablity_xuefen',
        component: ablity_xuefen,
        meta: {
          title: '勤博教育 | 我的学分'
        }
      },{
        path: 'jifen',
        name: 'jifen',
        component: jifen,
        meta: {
          title: '勤博教育 | 我的积分'
        }
      },{
        path: 'plan',
        name: 'plan',
        component: plan,
        meta: {
          title: '勤博教育 | 我的计划'
        }
      },  {
        path: 'plandetail',
        name: 'plandetail',
        component: plandetail,
        meta: {
          title: '勤博教育 | 计划详情'
        }
      },{
        path: 'shoucang',
        name: 'shoucang',
        component: shoucang,
        meta: {
          title: '勤博教育 | 我的收藏'
        }
      },{
        path: 'fapiaojilu',
        name: 'fapiaojilu',
        component: fapiaojilu,
        meta: {
          title: '勤博教育 | 开票记录'
        }
      },{
        path: 'applyfapiao',
        name: 'applyfapiao',
        component: applyfapiao,
        meta: {
          title: '勤博教育 | 发票申请'
        }
      },{
        path: 'msg',
        name: 'msg',
        component: msg,
        meta: {
          title: '勤博教育 | 我的消息',
          navShow: true
        },

      },{
        path: 'msgdetail',
        name: 'msgdetail',
        component: msgdetail,
        meta: {
          title: '勤博教育 | 消息详情'
        }
      },{
        path: 'nextjiaoyu',
        name: 'nextjiaoyu',
        component: nextjiaoyu,
        meta: {
          title: '勤博教育 | 继续教育'
        }
      },{
        path: '/zhengming',
        name: 'zhengming',
        component: zhengming,
        meta: {
          title: '勤博教育 | 学习证明'
        }
      }]
    },
    {
      path: '/continuCourseDetail',
      name: 'continuCourseDetail',
      component: continuCourseDetail,
      meta: {
        title: '勤博教育 | 继续教育课程'
      }
    },
    {
      path: '/xuefentransform',
      name: 'xuefentransform',
      component: xuefentransform,
      meta: {
        title: '勤博教育 | 学分银行'
      }
    },
    {
      path: '/applayjilu',
      name: 'applayjilu',
      component: applayjilu,
      meta: {
        title: '勤博教育 | 申请学分转换'
      }
    },
    {
      path: '/shenbaoactive',
      name: 'shenbaoactive',
      component: shenbaoactive,
      meta: {
        title: '勤博教育 | 活动申报'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        title: '勤博教育 | 关于勤博教育',
        mainMenu: 'about'
      },
      children:[
        {
          path: '/about1',
          name: 'about1',
          component: about,
          meta: {
            title: '勤博教育 | 关于勤博教育',
            mainMenu: 'about'
          },
      }, {
          path: '/about2',
          name: 'about2',
          component: about,
          meta: {
            title: '勤博教育 | 关于勤博教育',
            mainMenu: 'about'
          },
        }]
    },
    {
      path: '/vip',
      name: 'vip',
      component: vip,
      meta: {
        title: '勤博教育 | VIP会员'
      }
    },
    {
      path: '/linkus',
      name: 'linkus',
      component: linkus,
      meta: {
        title: '勤博教育 | 联系我们'
      }
    },
    {
      path: '/zhuanhuan',
      name: 'zhuanhuan',
      component: zhuanhuan,
      meta: {
        title: '勤博教育 | 学分转换'
      }
    },{
      path: '/zhuanhuan1',
      name: 'zhuanhuan1',
      component: zhuanhuan1,
      meta: {
        title: '勤博教育 | 学分转换'
      }
    },
    {
      path: '/zhuanhuan2',
      name: 'zhuanhuan2',
      component: zhuanhuan2,
      meta: {
        title: '勤博教育 | 学分转换'
      }
    },

    {
       path: '/college',
       name: 'college',
       component: college,
      meta: {
         title: '勤博教育 | 国开物业学院',
        mainMenu:'college'
       },
       children:[{
         path: '/college2',
         name: 'college2',
         component: college,
         meta: {
           title: '勤博教育 | 国开物业学院',
           mainMenu:'college'
         },},
         {
           path: '/college3',
           name: 'college3',
           component: college,
           meta: {
             title: '勤博教育 | 国开物业学院',
             mainMenu:'college'
           },},
         {
           path: '/college4',
           name: 'college4',
           component: college,
           meta: {
             title: '勤博教育 | 国开物业学院',
             mainMenu:'college'
           },},
         {
           path: '/college5',
           name: 'college5',
           component: college,
           meta: {
             title: '勤博教育 | 国开物业学院',
             mainMenu:'college'
           },}

    ]
    },


    // {
    //   path: '/collegeLayout',
    //   name: 'collegeLayout',
    //   component: collegeLayout,
    //   meta: {
    //     title: '勤博教育 | 国开物业学院'
    //   },
    //   children:[
    //     {
    //       path: '',
    //       redirect: 'college'
    //     },
    //     {
    //     path: ':tab',
    //     name: 'college22',
    //     component: college22,
    //       props: true ,// 重要：将路由参数作为 props 传递给组件
    //     meta: {
    //       title: '勤博教育 | 国开物业学院'
    //     }}]
    // }
    ,{
      path: '/changeScore',
      name: 'changeScore',
      component: changeScore,
      meta: {
        title: '勤博教育 | 学分转换'
      }
    },
    {
      path: '/buy',
      name: 'buy',
      component: buy,
      meta: {
        title: '勤博教育 | 结算中心'
      }
    },
    {
      path: '/courselist',
      name: 'courselist',
      component: courselist,
      meta: {
        title: '勤博教育 | 课程列表'
      }
    },
    {
      path: '/coursedetail',
      name: 'coursedetail',
      component: coursedetail,
      meta: {
        title: '勤博教育 | 课程详情'
      }
    },
    {
      path: '/coursedetailxcx',
      name: 'coursedetailxcx',
      component: coursedetailxcx,
      meta: {
        title: '勤博教育 | 课程详情'
      }
    },
    {
      path: '/ceping',
      name: 'ceping',
      component: ceping,
      meta: {
        title: '勤博教育 | 测培一体化体系',
        mainMenu: 'ceping'
      },
      children:[
        {
          path: '/srlcp',
          name: 'srlcp',
          component: ceping,
          meta: {
            title: '勤博教育 | 测培一体化体系',
            mainMenu: 'ceping'
          },
        },
        {
          path: '/srlcp2',
          name: 'srlcp2',
          component: ceping,
          meta: {
            title: '勤博教育 | 测培一体化体系',
            mainMenu: 'ceping'
          },
        },
        {
          path: '/srlcp3',
          name: 'srlcp3',
          component: ceping,
          meta: {
            title: '勤博教育 | 测培一体化体系',
            mainMenu: 'ceping'
          },
        }
      ]
    },
    {
      path: '/ceping1',
      name: 'ceping1',
      component: ceping1,
      meta: {
        title: '勤博教育 | 测培一体化体系'
      }
    },
    {
      path: '/ceping2',
      name: 'ceping2',
      component: ceping2,
      meta: {
        title: '勤博教育 | 测培一体化体系'
      }
    },
    {
      path: '/ceping3',
      name: 'ceping3',
      component: ceping3,
      meta: {
        title: '勤博教育 | 测培一体化体系'
      }
    },
    {
      path: '/ceping4',
      name: 'ceping4',
      component: ceping4,
      meta: {
        title: '勤博教育 | 测培一体化体系'
      }
    },
    {
      path: '/question',
      name: 'question',
      component: question,
      meta: {
        title: '勤博教育 | 能力测评'
      }
    },
    {
      path: '/que1',
      name: 'que1',
      component: que1,
      meta: {
        title: '勤博教育 | 能力测评'
      }
    },
    {
      path: '/que2',
      name: 'que2',
      component: que2,
      meta: {
        title: '勤博教育 | 能力测评'
      }
    },
    {
      path: '/que3',
      name: 'que3',
      component: que3,
      meta: {
        title: '勤博教育 | 能力测评'
      }
    },
    {
      path: '/que4',
      name: 'que4',
      component: que4,
      meta: {
        title: '勤博教育 | 能力测评'
      }
    },
    {
      path: '/jieguo',
      name: 'jieguo',
      component: jieguo,
      meta: {
        title: '勤博教育 | 测评结果'
      }
    },
    {
      path: '/renzheng',
      name: 'renzheng',
      component: renzheng,
      meta: {
        title: '勤博教育 | 实名认证'
      }
    },
    {
      path: '/xuefenrending',
      name: 'xuefenrending',
      component: xuefenrending,
      meta: {
        title: '勤博教育 | 学分认定'
      }
    },
    {
      path: '/zhengshuchaxun',
      name: 'zhengshuchaxun',
      component: zhengshuchaxun,
      meta: {
        title: '勤博教育 | 证书查询'
      }
    },
    {
      path: '/zhengshulist',
      name: 'zhengshulist',
      component: zhengshulist,
      meta: {
        title: '勤博教育 | 我的证书'
      }
    },
    {
      path: '/zhengshu',
      name: 'zhengshu',
      component: zhengshu,
      meta: {
        title: '勤博教育 | 我的证书'
      }
    },
    {
      path: '/confirmrending',
      name: 'confirmrending',
      component: confirmrending,
      meta: {
        title: '勤博教育 | 我的证书'
      }
    },
    {
      path: '/rendingsuccess',
      name: 'rendingsuccess',
      component: rendingsuccess,
      meta: {
        title: '勤博教育 | 学分认定'
      }
    },
    {
      path: '/step',
      name: 'step',
      component: step,
      meta: {
        title: '勤博教育 | 学分认定'
      }
    },
    {
      path: '/step1',
      name: 'step1',
      component: step1,
      meta: {
        title: '勤博教育 | 学分认定'
      }
    },
    {
      path: '/step2',
      name: 'step2',
      component: step2,
      meta: {
        title: '勤博教育 | 学分认定'
      }
    },
    {
      path: '/step3',
      name: 'step3',
      component: step3,
      meta: {
        title: '勤博教育 | 学分认定'
      }
    },
    {
      path: '/step4',
      name: 'step4',
      component: step4,
      meta: {
        title: '勤博教育 | 学分认定'
      }
    },
    {
      path: '/hangyezhengshu',
      name: 'hangyezhengshu',
      component: hangyezhengshu,
      meta: {
        title: '勤博教育 | 行业证书'
      }
    },
    {
      path: '/baokao',
      name: 'baokao',
      component: baokao,
      meta: {
        title: '勤博教育 | 行业证书'
      }
    },
    {
      path: '/chaxun',
      name: 'chaxun',
      component: chaxun,
      meta: {
        title: '勤博教育 | 行业证书'
      }
    },
    {
      path: '/dengji',
      name: 'dengji',
      component: dengji,
      meta: {
        title: '勤博教育 | 行业证书'
      }
    },
    {
      path: '/continues',
      name: 'continues',
      component: continues,
      meta: {
        title: '勤博教育 | 继续教育'
      }
    },
    {
      path: '/kaoshi',
      name: 'kaoshi',
      component: kaoshi,
      meta: {
          title: '勤博教育 | 认证考试'
      }
    },
    {
      path: '/startkaoshi',
      name: 'startkaoshi',
      component: startkaoshi,
      meta: {
          title: '勤博教育 | 认证考试'
      }
    },
    {
      path: '/kaoshiAccount',
      name: 'kaoshiAccount',
      component: kaoshiAccount,
      meta: {
        title: '勤博教育 | 完善资料'
      }
    },
    {
      path: '/shenfen',
      name: 'shenfen',
      component: shenfen,
      meta: {
        title: '勤博教育 | 身份认证'
      }
    },
    {
      path: '/jilushenbao',
      name: 'jilushenbao',
      component: jilushenbao,
      meta: {
        title: '勤博教育 | 继续教育'
      }
    },
    {
      path: '/hasjiaoyu',
      name: 'hasjiaoyu',
      component: hasjiaoyu,
      meta: {
        title: '勤博教育 | 教育经历'
      }
    },
    {
      path: '/addEducation',
      name: 'addEducation',
      component: addEducation,
      meta: {
        title: '勤博教育 | 新增教育'
      }
    },
    {
      path: '/jobjingli',
      name: 'jobjingli',
      component: jobjingli,
      meta: {
        title: '勤博教育 | 工作经历'
      }
    },
    {
      path: '/addjob',
      name: 'addjob',
      component: addjob,
      meta: {
        title: '勤博教育 | 新增工作'
      }
    },
    {
      path: '/peixun',
      name: 'peixun',
      component: peixun,
      meta: {
        title: '勤博教育 | 培训经历'
      }
    },
    {
      path: '/addpeixun',
      name: 'addpeixun',
      component: addpeixun,
      meta: {
        title: '勤博教育 | 新增培训'
      }
    },
    {
      path: '/haszhengshu',
      name: 'haszhengshu',
      component: haszhengshu,
      meta: {
        title: '勤博教育 | 证书登记'
      }
    },
    {
      path: '/addzhengshu',
      name: 'addzhengshu',
      component: addzhengshu,
      meta: {
        title: '勤博教育 | 新增证书'
      }
    },
    {
      path: '/applyExa',
      name: 'applyExa',
      component: applyExa,
      meta: {
        title: '勤博教育 | 报名考试'
      }
    },
    {
      path: '/buyExam',
      name: 'buyExam',
      component: buyExam,
      meta: {
          title: '勤博教育 | 报名缴费'
      }
    },
    {
      path: '/continuBuy',
      name: 'continuBuy',
      component: continuBuy,
      meta: {
        title: '勤博教育 | 继续教育缴费'
      }
    },
    {
      path: '/occupation',
      name: 'occupation',
      component: occupation,
      meta: {
        title: '勤博教育 | 五博系列课程',
        mainMenu:'occupation'
      },
      children:[
        {
          path: '/zypx',
          name: 'zypx',
          component: occupation,
          meta: {
            title: '勤博教育 | 五博系列课程',
            mainMenu:'occupation'
          },},
        {
          path: '/zypx2',
          name: 'zypx2',
          component: occupation,
          meta: {
            title: '勤博教育 | 五博系列课程',
            mainMenu:'occupation'
          },},
        {
          path: '/zypx3',
          name: 'zypx3',
          component: occupation,
          meta: {
            title: '勤博教育 | 五博系列课程',
            mainMenu:'occupation'
          },
        },
        {
          path: '/zypx4',
          name: 'zypx4',
          component: occupation,
          meta: {
            title: '勤博教育 | 五博系列课程',
            mainMenu:'occupation'
          },
        },
        {
          path: '/zypx5',
          name: 'zypx5',
          component: occupation,
          meta: {
            title: '勤博教育 | 五博系列课程',
            mainMenu:'occupation'
          },
        }
      ]
    },
    {
      path: '/global',
      name: 'global',
      component: global,
      meta: {
        title: '勤博教育 | 国际教育',
        mainMenu: 'global'
      },
      children:[
        {
          path: '/global2',
          name: 'global2',
          component: global,
          meta: {
            title: '勤博教育 | 国际教育',
            mainMenu: 'global'
          },
        },
        {
          path: '/global3',
          name: 'global3',
          component: global,
          meta: {
            title: '勤博教育 | 国际教育',
            mainMenu: 'global'
          },
        }
      ]
    },
    {
      path: '/skill',
      name: 'skill',
      component: skill,
      meta: {
        title: '勤博教育 | 职业技能认定培训'
      },
      children:[
        {
          path: '/jnrd',
          name: 'jnrd',
          component: skill,
          meta: {
            title: '勤博教育 | 职业技能认定培训',
            mainMenu: 'skill'
          },
        },
        {
          path: '/jnrd2',
          name: 'jnrd2',
          component: skill,
          meta: {
            title: '勤博教育 | 职业技能认定培训',
            mainMenu: 'skill'
          },
        },
        {
          path: '/jnrd3',
          name: 'jnrd3',
          component: skill,
          meta: {
            title: '勤博教育 | 职业技能认定培训',
            mainMenu: 'skill'
          },
        },
        {
          path: '/jnrd4',
          name: 'jnrd4',
          component: skill,
          meta: {
            title: '勤博教育 | 职业技能认定培训',
            mainMenu: 'skill'
          },
        },
        {
          path: '/jnrd5',
          name: 'jnrd5',
          component: skill,
          meta: {
            title: '勤博教育 | 职业技能认定培训',
            mainMenu: 'skill'
          },
        }
      ]
    },
  ],
  linkExactActiveClass:'navActive'


})



// WEBPACK FOOTER //
// ./src/router/index.js